<template>
  <div>
    <Cookie />
    <component :is="layout" />
    <template v-if="!footless">
      <Footer />
      <FooterSection />
    </template>
  </div>
</template>
<script>
import Cookie from '@/components/common/Cookie.vue'
import Footer from '@/components/common/layout/Footer.vue'
import FooterSection from '@/components/common/layout/FooterSection.vue'
import DefaultLayout from './DefaultLayout.vue'
import DefaultLayoutFluid from './DefaultLayoutFluid.vue'
import EmptyLayout from './EmptyLayout.vue'
import EmptyLayoutContainer from './EmptyLayoutContainer.vue'
import { mapState } from 'vuex'

export default {
  name: 'RootLayout',
  components: {
    Cookie,
    Footer,
    DefaultLayout,
    DefaultLayoutFluid,
    EmptyLayout,
    EmptyLayoutContainer,
    FooterSection,
  },
  computed: {
    ...mapState('ui', ['footless']),
    layout() {
      return this.$route.meta?.layout || 'DefaultLayout'
    },
  },
}
</script>
